import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '@env/environment';
import * as searchActions from '@app/marketplace/products/state/product-search/search-actions';
import {ProductProviderEnum} from '@app/marketplace/core/enum/productProvider';
import {TrackingComponent} from '@app/shared/components/tracking/tracking.component';
import {Meta, Title} from '@angular/platform-browser';
import {FingerprintService} from '@app/services/fingerprint.service';
import {StorageService} from '@app/services/storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UrlService} from '@app/services/url.service';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-market-best-buy',
  templateUrl: './market-best-buy.component.html',
  styleUrls: ['./market-best-buy.component.css']
})
export class MarketBestBuyComponent extends TrackingComponent implements OnInit {
  title = 'Cubatel | Tecnología de Best Buy para Cuba';
  description = 'Descubre tecnología, electrodomésticos y más de Best Buy con Cubatel. Envíos rápidos y entregas confiables en Cuba';
  keywords = 'Best Buy Cuba, comprar Best Buy desde Cuba, envíos Best Buy a Cuba, tecnología Best Buy Cuba';

  ProviderType = ProductProviderEnum;


  constructor(private metaService: Meta,
              private fingerprintService: FingerprintService,
              private storageService: StorageService,
              private route: ActivatedRoute,
              private titleService: Title,
              private urlService: UrlService,
              private router: Router,
              private store: Store<any>,
              @Inject(PLATFORM_ID) private platformId) {
    super(urlService, fingerprintService, storageService, route, 'stu_btn_best_buy');
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      this.getBestBuyProducts();
    }

    this.metaService.updateTag({
      name: 'description',
      content: this.description,
    });
    this.metaService.updateTag({ name: 'keywords', content: this.keywords });
    this.metaService.updateTag({ name: 'robots', content: 'all' });
    this.metaService.updateTag({ property: 'og:title', content: this.title });
    this.metaService.updateTag({
      property: 'og:description',
      content: this.description,
    });
    this.metaService.updateTag({
      property: 'og:url',
      content: `${environment.host}${this.router.url}`,
    });
    this.titleService.setTitle(this.title);
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }

  randomSearch() {}

  mostPopularProducts(arr: any[]): any {
    const indiceAleatorio = Math.floor(Math.random() * arr.length);
    return arr[indiceAleatorio];
  }

  getBestBuyProducts() {
    this.store.dispatch(searchActions.SetProvider({provider: ProductProviderEnum.BestBuy}));
  }

}
